import { useEffect, useState } from 'react'

import { getRequestProfileEmailThreadsTotal } from '../../RequestProfileTabEmails.api'
import {
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_ALL,
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_INBOX,
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_SENT,
} from '../../RequestProfileTabEmails.constants'

function useRequestProfileTabEmailsFoldersUnreadCount({
  audience,
  isEnabled,
  outboundUuid,
  requestId,
}) {
  const [foldersUnreadCount, setFoldersUnreadCount] = useState(null)

  function handleReloadFoldersUnreadCount() {
    return getRequestProfileEmailThreadsTotal({
      audience,
      outboundUuid,
      requestId,
    })
      .then(response => {
        const allUnread = response?.data?.all?.unread ?? null

        setFoldersUnreadCount({
          [REQUEST_PROFILE_TAB_EMAILS_FOLDER_ALL]: allUnread,
          [REQUEST_PROFILE_TAB_EMAILS_FOLDER_INBOX]:
            response?.data?.inbox?.unread ?? null,
          [REQUEST_PROFILE_TAB_EMAILS_FOLDER_SENT]:
            response?.data?.sent?.unread ?? null,
        })

        return allUnread
      })
      .catch(() => {
        setFoldersUnreadCount(null)
      })
  }

  useEffect(() => {
    if (isEnabled) {
      handleReloadFoldersUnreadCount()
    }
  }, [isEnabled])

  return { foldersUnreadCount, handleReloadFoldersUnreadCount }
}

export default useRequestProfileTabEmailsFoldersUnreadCount
